(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.createWxError = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports["default"] = _default;

  function _default(res) {
    if (!res) {
      return new Error("wx: unknown");
    }

    if (res instanceof Error) {
      return res;
    }

    if (typeof res === "string") {
      return new Error(res);
    }

    var err = new Error(res.errMsg || "wx:unknown");
    Object.defineProperty(err, "raw", {
      get: function get() {
        return res;
      }
    });
    return err;
  }
});
//# sourceMappingURL=createWxError.js.map